import { Grid } from "@material-ui/core";
import { useEffect, useState } from "react"
import { queueService } from "../services";
import { CircularProgress } from '@material-ui/core';

export const DuplicatePath = "/duplicates";

export default function Duplicates() {
    const [duplicates, setDuplicates] = useState([]);
    const [calls, setCalls] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        queueService.getCallQueue().then((resp) => {
                setCalls(resp.Data.Calls)
            });
    }, [])

    useEffect(() => {
        if (calls.length > 0) {
            setLoading(true);
            let justCalls = calls.reduce((acc, obj) => [...acc, ...obj.contacts], []);

            let duplicates = justCalls.map((call, index) => {
                let foundIndex = justCalls.findIndex(sc => {
                    return sc.PhoneNumber === call.PhoneNumber && sc.PipedriveRebirthCount === call.PipedriveRebirthCount;
                });

                if (foundIndex !== index) {
                    // console.log('Duplicate: ' + JSON.stringify(call))
                    return call
                }
                return null;
            }).filter(i => i)
            duplicates.sort((a, b) => {
                if (a.PhoneNumber == b.PhoneNumber) {
                    return a.PipedriveDealID > b.PipedriveDealID ? 1 : -1;
                }
                return a.PhoneNumber > b.PhoneNumber ? 1 : -1
            })
            setDuplicates(duplicates)
            setLoading(false)
        }
    }, [calls])

    console.log(`${duplicates.length} duplicates found`)
    return (
        <>
            <div style={{position: 'absolute', top: 0, bottom: 0, left: 0, right: 0, display: `${loading ? 'block' : 'none'}`}}>
                <div className={'nick'} style={{height: '100%', width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                    <CircularProgress />
                </div>
            </div>
            <h1 style={{fontFamily: "Ink", textAlign: "center", padding: "20px"}}>
                Duplicate Calls {duplicates.length > 0 && `( ${duplicates.length} )`}
            </h1>
            <Grid container spacing={3} style={{padding: "20px"}}>
                <Grid item xs={12}>
                    <table style={{maxWidth: '800px', margin: 'auto', width: '100%'}}>
                        <thead>
                            <tr>
                                <td>Phone Number</td>
                                <td>Deal Link</td>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                duplicates.map((d, ix) => {
                                    return (
                                        <tr key={`tr-dupe-${ix}`}>
                                            <td>{d.PhoneNumber}</td>
                                            <td><a href={`https://instylesolar3.pipedrive.com/deal/${d.PipedriveDealID}`} target="_blank">{d.PipedriveDealID}</a></td>
                                        </tr>
                                    )
                                })
                            }
                        </tbody>
                    </table>
                </Grid>
            </Grid>
        </>
    )
}